import { loadStripe } from '@stripe/stripe-js'
import type { Stripe } from '@stripe/stripe-js'

const cache = new Map<string, Promise<Stripe | null>>()

export const getStripe = () => {
  const key = import.meta.env.VITE_STRIPE_PUBLIC_SEVALLA

  if (!key) {
    return null
  }

  if (!cache.has(key)) {
    cache.set(key, loadStripe(key))
  }

  return cache.get(key) ?? null
}
